<template lang="pug">
b-modal#editPromoVoucherEndDate(
  ref="editPromoVoucherEndDate"
  :title="$t('ui.combine.edit_promotion_voucher_end_date')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.promotion_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="promotion_id"
        required
        type="text"
        v-model="promotion_id"
        disabled
      )
    b-form-group(:label="$t('ui.start_date')").mb-0
      b-input-group(size="sm")
        date-picker.form-control-sm(
          ref="start_date"
          :config="localeDate"
          v-model="start_date"
          disabled
        )
    b-form-group(:label="$t('ui.start_time')").mb-0
      b-input-group(size="sm")
        date-picker.form-control-sm(
          ref="start_time"
          :config="localeTime"
          v-model="start_time"
          disabled
        )
    b-form-group(:label="$t('ui.end_date')").mb-0
      b-form-select.col-4(v-model="endDt" size="sm")
        option(value="one_week") {{ $t('ui.one_week') }}
        option(value="two_week") {{ $t('ui.two_week') }}
        option(value="one_month") {{ $t('ui.one_month') }}
        option(value="two_month") {{ $t('ui.two_month') }}
        option(value="six_month") {{ $t('ui.six_month') }}
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      promotion_id: "",
      start_date: this.$moment(new Date).format('YYYY-MM-DD'),
      start_time: "00:00:00",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      localeDate: {
        format: "YYYY-MM-DD",
        useCurrent: true
      },
      localeTime: {
        format: "HH:mm:ss",
        useCurrent: true
      },
      endDt: "one_week"
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID
    }
  },
  methods: {
    formatEndDate() {
      var val = ''
      switch(this.endDt) {
        case 'one_week':
          val = this.$moment(new Date(this.end_date + ' 23:59:59')).add(1, 'week').format('YYYY-MM-DD');
          break;
        case 'two_week':
          val = this.$moment(new Date(this.end_date + ' 23:59:59')).add(2, 'week').format('YYYY-MM-DD');
          break;
        case 'one_month':
          val = this.$moment(new Date(this.end_date + ' 23:59:59')).add(1, 'months').format('YYYY-MM-DD');
          break;
        case 'two_month':
          val = this.$moment(new Date(this.end_date + ' 23:59:59')).add(2, 'months').format('YYYY-MM-DD');
          break;
        case 'six_month':
          val = this.$moment(new Date(this.end_date + ' 23:59:59')).add(6, 'months').format('YYYY-MM-DD');
          break;
      }

      return val;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      let url = config.promotionVoucherEndDateTimeUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        promotion_id: this.promotion_id,
        end_date: this.formatEndDate(),
        end_time: "23:59:59",
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.editPromoVoucherEndDate.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "edit_promotion_voucher_end_date", this.feedback.status);
                this.$refs.editPromoVoucherEndDate.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.endDt = "one_week"
    },
    shown: function() {
      this.promotion_id = this.item.promotion_id;
      this.start_date = this.$moment(this.item.start_date).format('YYYY-MM-DD');
      this.end_date = this.$moment(this.item.end_date).format('YYYY-MM-DD');
      this.start_time = this.$moment(this.start_date + ' ' +this.item.start_time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss');
    }
  },
};
</script>
